// extracted by mini-css-extract-plugin
export default {"list-prop-wrap":"ListPropertyRedirect_list-prop-wrap__nq9nw"};